export default __webpack_public_path__ + "static/media/grondplan_fr.eb3a6a5f.svg";